module.exports = __webpack_public_path__ + "media/images/smart_phone/login/202001/i_demo-227a1a337f5bce11dc769c62cafdbdb1.png";